module.exports = __webpack_public_path__ + "media/images/noise-6ab2ac45.jpeg";